import { type PageTag } from "./models";

if (!Array.isArray((window as any).odendo.globals.motdPageTags))
    (window as any).odendo.globals.motdPageTags = [];

export const pageTags: PageTag[] = (window as any).odendo.globals.motdPageTags;
export const isCheckoutPage = window.odendo.globals.isCheckout === true;

import { reactive } from "vue";

(async function async() {
    reactive(pageTags);
})();
